module.exports = __webpack_public_path__ + "img/plashka-ru.f60492a7.jpg";